var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavepostIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "savepost_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04023 16.64C8.61023 16.21 9.39023 16.21 9.95023 16.64L13.3502 19.19C14.4002 19.98 15.9002 19.23 15.9002 17.91V4.09003C15.9002 3.21003 15.1902 2.50003 14.3102 2.50003H3.68023C2.80023 2.50003 2.09023 3.21003 2.09023 4.09003V17.91C2.09023 19.22 3.59023 19.97 4.64023 19.19L8.04023 16.64ZM9.00023 17.91L12.4002 20.46C14.5002 22.04 17.5002 20.54 17.5002 17.91V4.09003C17.5002 2.33003 16.0702 0.900024 14.3102 0.900024H3.68023C1.92023 0.900024 0.490234 2.33003 0.490234 4.09003V17.91C0.490234 20.54 3.49023 22.04 5.59023 20.46L8.99023 17.91H9.00023Z",
    fill: "#ACACAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavepostIcon);
export default __webpack_public_path__ + "static/media/savepost_icon.103bb2cccefe08fb6acfe510d74c07b9.svg";
export { ForwardRef as ReactComponent };